import { Validators } from '@angular/forms';
import CustomValidators from '../custom-validators.model';

export default class OtherDocuments {
  snils = ['', [Validators.required, CustomValidators.onlyNum, CustomValidators.snilsLen]];
  inn = ['', [Validators.required, CustomValidators.onlyNum, CustomValidators.personInnLen]];
}
